import { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { ArtistContactDetails } from 'src/Containers/SignUp/components/ArtistContactDetails'

import { NoAuthPageLayout } from '../../Components/NoAuthPageLayout'
import { CreateCampaignBreadcrumbsNoAuth } from '../../Components/CreateCampaignBreadcrumbsNoAuth'
import { HelmetTitle } from '../../Components/HelmetTitle'

const Container = styled.div`
  display: flex;
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    gap: 40px;
  }
`

export const ArtistRegisterPageWithoutTrack: FC = () => (
  <NoAuthPageLayout>
    <HelmetTitle />

    <Container>
      <CreateCampaignBreadcrumbsNoAuth
        platform={CampaignPlatformTypeEnum.SPOTIFY}
      />
      <ArtistContactDetails />
    </Container>
  </NoAuthPageLayout>
)
